import React, { useEffect } from "react";
import { useState } from "react";
import compose from "recompose/compose";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Filter from "./components/Filter";
import Table from "./components/Table";
import { db } from "firebase/client";
import { reportSelections } from "../reportSelections";
// mui
import { Card, Hidden, Typography } from "@material-ui/core";

// components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

// styling
import Style from "assets/jss/material-dashboard-pro-react/views/reportsStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import { zip } from "lodash";
import { ptsFormula } from "globalCalculationFunction/globalCalculationFunction";
import Loader from "components/Loader/Loader";
import { use } from "react";

const headers = [
  { label: "Merchant #", key: "merchantNumber" },
  { label: "Merchant Name", key: "name" },
  { label: "# of Transactions", key: "quantity" },
  { label: "Points Earned", key: "pointsEarned" },
  { label: "Month Total", key: "monthTotal" },
  // { label: "", key: "action" },
];

const csvHeaders = [
  { label: "ISO Name", key: "isoName" },
  { label: "Merchant #", key: "merchantNumber" },
  { label: "Merchant Name", key: "name" },
  { label: "# of Transactions", key: "quantity" },
  { label: "Points Earned", key: "pointsEarned" },
  { label: "Month Total", key: "monthTotal" },
  { label: "Date", key: "reportDate" },
  { label: "Basis Points", key: "userBasisPts" },
  { label: "Boarded Date", key: "boardDate" },
  { label: "Deactivated Date", key: "deactivatedDate" }
];

const csvAllHeaders = [
  { label: "ISO Name", key: "isoName" },
  { label: "Merchant #", key: "merchantNumber" },
  { label: "Merchant Name", key: "name" },
  { label: "Quantity", key: "quantity" },
  { label: "Points Earned", key: "pointsEarned" },
  { label: "Day Total", key: "dayTotal" },
  { label: "Date", key: "reportDate" },
  { label: "Basis Points", key: "userBasisPts" },
  { label: "Boarded Date", key: "boardDate" },
  { label: "Deactivated Date", key: "deactivatedDate" }
];


export function SalesByMerchant(props) {
  const { classes, history, userType, user } = props;
  const [reportArr, setReportArr] = useState([]);
  const [sortValue, setSortValue] = useState("");
  const [fromDate, setFromDate] = useState(moment().format("MMMM DD YYYY"));
  const itemsPerPage = 9;
  const [pageNumber, setPageNumber] = useState(0);
  const [index, setIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(itemsPerPage);
  const [batchInfoArr, setBatchInfoArr] = useState(false);
  const [copyArr, setCopyArr] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [lastVisible, setLastVisible] = useState("")
  const [dateFilter, setDateFilter] = useState(moment().format("MMM YYYY"));
  const [dateCheck, setDateCheck] = useState(true)
  const currMonthYear = moment().month() + "" + moment().year()
  const [firstRan, setFirstRan] = useState(false)
  const [dataLoaded, setDataLoaded] = useState(false)
  const [allBatch, setAllBatch] = useState([])
  const [allLoaded, setAllLoaded] = useState(false)

  const checkingDate = (date) => {
    let formattedDate = (moment(date).month()) + "" + moment(date).year()
    if (formattedDate === currMonthYear) {
      setDateCheck(true)
    } else {
      setDateCheck(false)
    }
  }


  const numberFormatterDecimals = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const numberFormatter = new Intl.NumberFormat("en-US", {});

  const handlePageClick = ({ selected }) => {
    setPageNumber(selected);
    setIndex(selected * itemsPerPage);
    setEndIndex(selected * itemsPerPage + itemsPerPage);
  };


  const handleSearch = () => {
    if (searchString) {
      const filtered = copyArr.filter((f) => {
        if (f.merchantName.toLowerCase().includes(searchString.toLowerCase())) {
          return true;
        }
        if (
          f.merchantNumber.toString().toLowerCase().includes(searchString.toLowerCase())
        ) {
          return true;
        }
      });
      setBatchInfoArr(filtered);
    } else {
      setBatchInfoArr(copyArr);
    }
  };

  const increaseDate = (date) => {
    setDataLoaded(false)
    setFirstRan(false)
    setLastVisible("")
    setBatchInfoArr([])
    setCopyArr([])
    getInitData(date)

    setIndex(0);
    setEndIndex(itemsPerPage);
    setPageNumber(0);

    let newDate = moment(date, "MMM YYYY").add(1, "months").format("MMM YYYY");
    setDateFilter(newDate);
    checkingDate(newDate)
  };

  const decreaseDate = (date) => {
    setBatchInfoArr([])
    setCopyArr([])
    setDataLoaded(false)
    setFirstRan(false)
    setLastVisible("")

    setIndex(0);
    setEndIndex(itemsPerPage);
    setPageNumber(0);

    let newDate = moment(date, "MMM YYYY").subtract(1, "months").format("MMM YYYY")
    setDateFilter(newDate)
    checkingDate(newDate)

    getInitData(date)
  };

  useEffect(() => {
    reportSelections.map((data) => {
      if (data.type === "Admin" && (userType === "Administrator" || userType === "Admin")) {
        setReportArr((prevArr) => [...prevArr, data]);
      }
    });
  }, []);

  const getCompleteData = async (date) => {
    const merchDb = db.collection("merchants-live");
    let docArr = [];
    let count = 0;
    let currMonth = (moment(date).month()) + "" + moment(date).year()

    await merchDb
      .orderBy('merchantName')
      .startAfter(lastVisible)
      .limit(itemsPerPage)
      .get()
      .then(async (querySnapshots) => {
        if (!querySnapshots.empty) {
          await querySnapshots.forEach(async (doc) => {
            doc = doc.data()
            let userBasisPts = 0
            let docId = doc.docId
            let mid = doc.merchantNumber
            let merchantName = doc.merchantName
            let demo = doc.demo ? doc.demo : false
            let totalNetAmount = 0
            let totalPointsEarned = 0
            let totalTransactions = 0
            let newObj = {
              merchantName,
              merchantNumber: mid,
              parentDocId: docId,
              demo,
              totalNetAmount,
              totalPointsEarned,
              totalTransactions
            }
            await db
              .collection("users")
              .where("merchantId", "==", mid)
              .get()
              .then((snapshots) => {
                if (!snapshots.empty) {
                  snapshots.forEach((s) => {
                    s = s.data()
                    userBasisPts = s.userBasisPts;
                    newObj.IsoAdminCompanyName = s.IsoAdminCompanyName
                    newObj.userBasisPts = s.userBasisPts
                    newObj.boardDate = s.emailSendDate
                    newObj.email = s.email
                    newObj.deactivated = s.deactivated ? s.deactivated : false
                    newObj.deactivatedDate = s.deactivatedDate ? s.deactivatedDate : false
                  })
                }
              })
            await merchDb
              .doc(docId)
              .collection("batch-summary")
              .get()
              .then((subSnapshot) => {
                if (!subSnapshot.empty) {
                  subSnapshot.forEach((d) => {
                    d = d.data()
                    let formattedDate = (moment(d.reportDate).month()) + "" + moment(d.reportDate).year()
                    if (formattedDate === currMonth) {
                      totalNetAmount += Number(d.netAmount)
                      totalPointsEarned += ptsFormula(d.netAmount, userBasisPts)
                      totalTransactions += Number(d.transactionCount)
                    }
                    newObj.totalNetAmount = totalNetAmount
                    newObj.totalPointsEarned = totalPointsEarned
                    newObj.totalTransactions = totalTransactions
                  })
                } else {
                  newObj.totalNetAmount = totalNetAmount
                  newObj.totalPointsEarned = totalPointsEarned
                  newObj.totalTransactions = totalTransactions
                }
              })

            docArr.push(newObj)
            count++;
            if (count === querySnapshots.docs.length) {
              setLastVisible(querySnapshots.docs[querySnapshots.docs.length - 1])
              setBatchInfoArr(prev => [...prev, ...docArr])
              setCopyArr(prev => [...prev, ...docArr])
            }
          })
        } else {
          setDataLoaded(true)
        }
      })
  }



  const getInitData = async (date) => {
    const merchDb = db.collection("merchants-live");
    let docArr = [];
    let count = 0;
    let currMonth = (moment(date).month()) + "" + moment(date).year()

    merchDb
      .orderBy('merchantName')
      .limit(itemsPerPage)
      .get()
      .then((querySnapshots) => {
        if (!querySnapshots.empty) {
          querySnapshots.forEach(async (doc) => {
            doc = doc.data()
            let userBasisPts = 0
            let docId = doc.docId
            let mid = doc.merchantNumber
            let merchantName = doc.merchantName
            let demo = doc.demo ? doc.demo : false
            let totalNetAmount = 0
            let totalPointsEarned = 0
            let totalTransactions = 0
            let newObj = {
              merchantName,
              merchantNumber: mid,
              parentDocId: docId,
              demo,
              totalNetAmount,
              totalPointsEarned,
              totalTransactions
            }
            db
              .collection("users")
              .where("merchantId", "==", mid)
              .get()
              .then((snapshots) => {
                if (!snapshots.empty) {
                  snapshots.forEach((s) => {
                    s = s.data()
                    userBasisPts = s.userBasisPts;
                    newObj.IsoAdminCompanyName = s.IsoAdminCompanyName
                    newObj.userBasisPts = s.userBasisPts
                    newObj.boardDate = s.emailSendDate
                    newObj.email = s.email
                    newObj.deactivated = s.deactivated ? s.deactivated : false
                    newObj.deactivatedDate = s.deactivatedDate ? s.deactivatedDate : false
                  })
                }
              })
            await merchDb
              .doc(docId)
              .collection("batch-summary")
              .get()
              .then((subSnapshot) => {
                if (!subSnapshot.empty) {
                  subSnapshot.forEach((d) => {
                    d = d.data()
                    let formattedDate = (moment(d.reportDate).month()) + "" + moment(d.reportDate).year()
                    if (formattedDate === currMonth) {
                      totalNetAmount += Number(d.netAmount)
                      totalPointsEarned += ptsFormula(d.netAmount, userBasisPts)
                      totalTransactions += Number(d.transactionCount)
                    }
                    newObj.totalNetAmount = totalNetAmount
                    newObj.totalPointsEarned = totalPointsEarned
                    newObj.totalTransactions = totalTransactions
                  })
                } else {
                  newObj.totalNetAmount = totalNetAmount
                  newObj.totalPointsEarned = totalPointsEarned
                  newObj.totalTransactions = totalTransactions
                }
              })

            docArr.push(newObj)
            count++;
            if (count === querySnapshots.docs.length) {
              setLastVisible(querySnapshots.docs[querySnapshots.docs.length - 1])
              setBatchInfoArr(docArr)
              setCopyArr(docArr)
              setFirstRan(true)
            }
          })
        }
      })
  }

  const getAllData = async () => {
    const merchDb = db.collection("merchants-live");
    let docArr = [];
    const arr = [];
    let count = 0;

    await merchDb.get().then(async (querySnapshot) => {
      querySnapshot.docs.forEach(async (doc) => {
        let userBasisPts = 0;
        let IsoAdminCompanyName = ""
        let boardDate = ""
        let docId = doc.data().docId;
        let mid = doc.data().merchantNumber;
        let demo = doc.data().demo ? doc.data().demo : false
        arr.push(doc.data());

        await db
          .collection("users")
          .where("merchantId", "==", mid)
          .get()
          .then((snapshots) => {
            if (!snapshots.empty) {
              snapshots.forEach((s) => {
                s = s.data();
                IsoAdminCompanyName = s.IsoAdminCompanyName
                userBasisPts = s.userBasisPts;
                boardDate = s.emailSendDate
              });
            }
          });
        await merchDb
          .doc(docId)
          .collection("batch-summary")
          .get()
          .then((subSnapshot) => {
            if (subSnapshot.empty) {
              let merchantName = doc.data().merchantName
              let merchantNumber = doc.data().merchantNumber
              let email = doc.data().email;
              let newObj = {
                boardDate,
                reportDate: "N/A",
                pointsEarned: 0,
                netAmount: 0,
                transactionCount: 0,
                merchantNumber,
                merchantName,
                parentDocId: docId,
                userBasisPts,
                email,
                demo,
                IsoAdminCompanyName
              };
              docArr.push(newObj);
            } else {
              subSnapshot.docs.forEach((subDoc) => {
                subDoc = subDoc.data();
                let merchantName = doc.data().merchantName;
                let email = doc.data().email;
                let pointsEarned = ptsFormula(subDoc.netAmount, userBasisPts);
                let newObj = {
                  ...subDoc,
                  boardDate,
                  merchantName,
                  parentDocId: docId,
                  userBasisPts,
                  email,
                  demo,
                  IsoAdminCompanyName,
                  pointsEarned
                };
                docArr.push(newObj);
              });
            }
          });
        count++;
        if (count === querySnapshot.docs.length) {
          docArr.sort(
            (a, b) =>
              new Date(b.reportDate).getTime() -
              new Date(a.reportDate).getTime()
          );
          setAllBatch(docArr);
          setAllLoaded(true)
        }
      });
    });
  }
  useEffect(() => {
    if (firstRan && batchInfoArr.length > 0) {
      getCompleteData(dateFilter)
    }
  }, [batchInfoArr, firstRan])


  useEffect(() => {
    if (!batchInfoArr) {
      getInitData(dateFilter)
    }
    // getAllData()
  }, [])


  if (!batchInfoArr || !firstRan) return <Loader />;

  return (
    <div>
      <Hidden mdUp implementation="css">
        <div>
          <Typography
            variant="h2"
            className={classes.title}
            style={{ color: "#1A405F" }}
          >
            Please View Page on Desktop / Laptop
          </Typography>
        </div>
      </Hidden>

      <Hidden smDown implementation="css">
        <GridContainer>
          <GridItem xs={12}>
            <Typography variant="h2" className={classes.title}>
              Reports
            </Typography>
          </GridItem>

          <GridItem xs={12} style={{ marginTop: "20px" }}>
            <Card style={{ padding: "25px 20px 5px" }}>
              <GridContainer>
                <GridItem xs={12}>
                  <Filter
                    reportSelections={reportArr}
                    sortValue={sortValue}
                    setSortValue={setSortValue}
                    fromDate={fromDate}
                    csvData={batchInfoArr}
                    headers={csvHeaders}
                    numberFormatterDecimals={numberFormatterDecimals}
                    numberFormatter={numberFormatter}
                    searchString={searchString}
                    setSearchString={setSearchString}
                    handleSearch={handleSearch}
                    dateFilter={dateFilter}
                    setDateFilter={setDateFilter}
                    increaseDate={increaseDate}
                    decreaseDate={decreaseDate}
                    dateCheck={dateCheck}
                    allLoaded={allLoaded}
                    allBatch={allBatch}
                    csvAllHeaders={csvAllHeaders}
                  />
                </GridItem>

                <GridItem xs={12}>
                  <Table
                    history={history}
                    data={batchInfoArr}
                    pageNumber={pageNumber}
                    index={index}
                    endIndex={endIndex}
                    itemsPerPage={itemsPerPage}
                    handlePageClick={handlePageClick}
                    headers={headers}
                    numberFormatterDecimals={numberFormatterDecimals}
                    dataLoaded={dataLoaded}
                  />
                </GridItem>
              </GridContainer>
            </Card>
          </GridItem>
        </GridContainer>
      </Hidden>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    userId: state.auth.user.uid,
    userType: state.auth.user.userType,
    user: state.auth.user,
  };
}

function mapDispatchToProps(actions) {
  return (dispatch) => ({});
}

export default withRouter(
  compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
  )(SalesByMerchant)
);
